import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);


const store = new Vuex.Store({
  state: {
    cityname: "深圳",
	isMobile: null
  },
  mutations: {
	changeCityname(state, cityname) {
	  state.cityname = cityname;
	},
	changeIsMobile(state, isMobile) {
	  state.isMobile = isMobile;
	},
  }
})

export default store